module.exports = __webpack_public_path__ + "assets/media/endUserAvatar.047ccc5e.svg";